import React, { useState } from 'react';
import { Button, Radio, Select, Card } from 'antd';
import { PHSHeader } from '../../components/UI/header';
import { createCheckoutSession } from '../../api/stripe';

const sessionOptions = [
    { label: '25 Sessions: $5,500', value: 25, price: 5500 },
    { label: '50 Sessions: $11,000', value: 50, price: 11000 },
];

const paymentMethods = [
    { label: 'Bank Account', value: 'bank' },
    { label: 'Credit Card', value: 'card' },
];

export const SessionPurchasePage = () => {
    const [selectedSession, setSelectedSession] = useState(sessionOptions[0].value);
    const [paymentMethod, setPaymentMethod] = useState(paymentMethods[0].value);
    const [loading, setLoading] = useState(false);

    const initializePayment = async () => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('phs-user'));
        let amount = sessionOptions.find(option => option.value === selectedSession).price || 0;
        if (paymentMethod === 'card') {
            amount = Math.round(amount * 1.03); // Add 3% processing fee for card payments
        }
        try {
            const res = await createCheckoutSession({
                plan: 'annually',
                userId: user.id,
                email: user.email,
                type: 'Session Purchase',
                amount,
                payment_method: paymentMethod
            });

            window.location.href = res.url;
        } catch (err) {
            console.error("Failed to initialize payment:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleConfirm = () => {
        initializePayment();
    };

    return (
        <div>
            <PHSHeader />
            <div style={{ maxWidth: 400, margin: '40px auto', padding: 24 }}>
                <Card title="Purchase Concierge Sessions" bordered={false}>
                    <div style={{ marginBottom: 24 }}>
                        <Radio.Group
                            options={sessionOptions}
                            onChange={e => setSelectedSession(e.target.value)}
                            value={selectedSession}
                            optionType="button"
                            buttonStyle="solid"
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div style={{ marginBottom: 32 }}>
                        <div style={{ marginBottom: 8, fontWeight: 500 }}>Payment Method</div>
                        <Select
                            style={{ width: '100%' }}
                            value={paymentMethod}
                            onChange={setPaymentMethod}
                            options={paymentMethods}
                        />
                        {paymentMethod === 'card' && (
                            <div style={{ color: '#e74c3c', marginTop: 8, fontSize: 14 }}>
                                3% standard processing fees will be added to the bill
                            </div>
                        )}
                    </div>
                    <Button
                        type="primary"
                        block
                        size="large"
                        loading={loading}
                        onClick={handleConfirm}
                    >
                        Confirm
                    </Button>
                </Card>
            </div>
        </div>
    );
}